import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SetupParameterState, SetupParameterStore } from './setup-parameter.store';
import { Filters } from './setup-parameter.model';
import { SetupParameterKindListViewModel } from 'chronos-basedata-client';

@Injectable({ providedIn: 'root' })
export class SetupParameterQuery extends QueryEntity<SetupParameterState, SetupParameterKindListViewModel> {
  public isLoading$ = this.selectLoading();
  public filters$: Observable<Filters> = this.select((state) => state.filters);

  public setupParameterList$ = this.filters$.pipe(
    switchMap((filters) =>
      this.selectAll({
        filterBy: (setupParameter: SetupParameterKindListViewModel) => this.filterByExternalSetupParameter(filters, setupParameter)
      })
    )
  );

  constructor(protected store: SetupParameterStore) {
    super(store);
  }

  private filterByExternalSetupParameter(filters: Filters, setupParameter: SetupParameterKindListViewModel) {
    if (!filters.externalSetupParameterKindId) {
      return true;
    } else if (setupParameter.externalSetupParameterKindId) {
      return setupParameter.externalSetupParameterKindId.toLowerCase().includes(filters.externalSetupParameterKindId.toLowerCase());
    }

    return false;
  }
}
